import React, { useEffect, useRef, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { useFormik } from "formik";
import { Notification } from "../../utils/Notification";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/Button";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Preload } from "../../components/Preload";
import { Selected } from "../../components/Form/Selected";
import { useMutation, useQuery } from "@apollo/client";
import i18next from "i18next";
import { GET_CITIES_FILTER } from "../../graphql/Queries/CityQuery";
import { Loader } from "@googlemaps/js-api-loader";
import { GET_ESTATE } from "../../graphql/Queries/EstateQuery";
import {
  MODIFY_ESTATE,
  UPDATE_IMAGE,
} from "../../graphql/Mutations/EstateMutation";
import { TextInput } from "../../components/Form/TextInput";
import { EditProp } from "./FormEstate/EditProp";
import { Col, Modal } from "react-bootstrap";
import Fancybox from "../../components/Fancybox";
import { MultilangTextInput } from "../../components/Form/MultilangTextInput";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { finder, TARGET } from "../../utils/Dictionaries";
import moment from "moment";
import axios from "axios";
import whatsapp from "../../assets/images/32px-WhatsApp.svg.png";

function getSaleType(type) {
  const saleType = {
    1: "Только продаю",
    2: "Одновременно покупаю",
    3: "Нужна помощь риелтора",
  };
  return saleType[type];
}

export const FormEstate = ({ url }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let location = useLocation();
  const id = location.state ? location.state.id : null;
  let [searchParams, setSearchParams] = useSearchParams();
  const [modify] = useMutation(MODIFY_ESTATE);
  const [others, setOthers] = useState([]);
  const { data, refetch } = useQuery(GET_ESTATE, {
    variables: {
      id: Number(searchParams.get("id")),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });
  const formik = useFormik({
    initialValues: {
      id: 0,
      object_type_id: null,
      complex_id: null,
      user_type: null,
      target: null,
      estate_type: null,
      user_id: null,
      currency_id: null,
      ipoteka: null,
      sale_type: null,
      address: "",
      price: 0,
      video: "",
      status: null,
      city_id: null,
      area_id: null,
      place_id: null,
      lat: "",
      lng: "",
      title: {
        az: "",
        en: "",
        ru: "",
      },
      phone: "",
      price_by_meter: "",
      kupchaya: null,
      properties: [],
      reject_reason: 0,
      comment: "",
      description: "",
      images: [],
      email: "",
    },
    validationSchema: Yup.object({
      address: Yup.string().required(t("Объязательное поле")),
      reject_reason: Yup.number().when("status", {
        is: (value) => Number(value) === 4,
        then: (schema) => schema.min(1).required(),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: (values) => {
      setLoading(true);
      modify({
        variables: {
          id: Number(values.id),
          status: Number(values.status),
          reject_reason: Number(values.reject_reason),
          comment: values.comment,
          description: JSON.stringify(values.description),
          images: JSON.stringify(values.images),
          address: values.address,
          video: values.video,
          email: values.email,
          lat: String(values.lat),
          lng: String(values.lng),
          title: JSON.stringify(values.title),
          price: Number(values.price),
        },
      })
        .then((response) => {
          navigate(url);
          Notification(t("Все хорошо!"), "success");
        })
        .catch((error) => {
          Notification(error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });
  const [cities, setCities] = useState([]);
  const [objectTypes, setObjectTypes] = useState([]);
  const cityQuery = useQuery(GET_CITIES_FILTER, {
    variables: {
      country_id: Number(formik.values.country_id),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });
  const [showModal, toggleModal] = useState("");
  const [showModalLimit, toggleModalLimit] = useState("");
  const [rejectReason, setRejectReason] = useState([]);
  const [editProp, setEditProps] = useState(null);
  const [showModalMap, toggleModalMap] = useState(null);
  const [showModalOther, toggleModalOther] = useState(false);
  const [updateImage] = useMutation(UPDATE_IMAGE);
  const [searchAddress, setSearchAddress] = useState("");
  const marker = useRef(null);
  const googleInstance = useRef(null);
  const map = useRef(null);

  const loader = new Loader({
    apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
    version: "weekly",
    libraries: ["places", "marker"],
  });

  const changeImage = (id, action) => {
    updateImage({
      variables: {
        estate_id: Number(formik.values.id),
        image_id: Number(id),
        action,
      },
    })
      .then((resp) => {
        formik.setFieldValue("images", resp.data.updateImage);
      })
      .catch((error) => {
        toast.error(t("Произошла ошибка!"));
      });
  };

  const SortableItem = SortableElement(({ item }) => {
    return (
      <div className={"estate-image"}>
        <a data-fancybox="gallery" href={item.url} className={"overlap"}>
          {/*<a*/}
          {/*  data-fancybox="gallery"*/}
          {/*  className={"btn btn-xs btn-primary"}*/}
          {/*  href={item.url}*/}
          {/*>*/}
          {/*  {t("Увеличить")}*/}
          {/*</a>*/}
          <button
            type={"button"}
            onClick={() => changeImage(item.id, "is_index")}
            className={"btn btn-xs btn-info"}
          >
            {t("Главное фото")}
          </button>
          <button
            type={"button"}
            className={"btn btn-xs btn-info"}
            onClick={() => changeImage(item.id, "is_plan")}
          >
            {t("Планировка")}
          </button>
          <button
            type={"button"}
            className={"btn btn-xs btn-danger"}
            onClick={() => changeImage(item.id, "delete")}
          >
            {t("Удалить")}
          </button>
        </a>
        <img
          src={item.url}
          alt={"Image"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
        <div className={"label-status"}>
          {Number(item.is_index) === 1 && <span>{t("Главное фото")}</span>}
          {Number(item.is_plan) === 1 && <span>{t("Планировка")}</span>}
        </div>
      </div>
    );
  });

  const SortableList = SortableContainer(({ items }) => {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {items.map((item, index) => {
          return (
            <SortableItem key={`item-${index}`} index={index} item={item} />
          );
        })}
      </div>
    );
  });

  useEffect(() => {
    if (data) {
      data.estate.data[0].title.map((dic) => {
        formik.setFieldValue(`title.${dic.lang}`, dic.value);
      });
      setOthers(data.estate.data[0].others);
      formik.setFieldValue("id", data.estate.data[0].id);
      formik.setFieldValue("status", String(data.estate.data[0].status));
      formik.setFieldValue("address", String(data.estate.data[0].address));
      formik.setFieldValue("video", data.estate.data[0].video);
      formik.setFieldValue("price", data.estate.data[0].price);
      formik.setFieldValue("lat", data.estate.data[0].lat);
      formik.setFieldValue("lng", data.estate.data[0].lng);
      formik.setFieldValue("email", data.estate.data[0].user?.email);
      formik.setFieldValue(
        "reject_reason",
        data.estate.data[0].reject_reason !== null
          ? String(data.estate.data[0].reject_reason)
          : 0,
      );
      formik.setFieldValue("comment", data.estate.data[0].comment);
      formik.setFieldValue("images", data.estate.data[0].images);
      data.estate.data[0].description.map((dic) => {
        formik.setFieldValue(`description.${dic.lang}`, dic.value);
      });
    }
    if (data && data.estateRejectReason) {
      const rejectReason = data.estateRejectReason.map((reason) => {
        const name = reason.title.find((e) => e.lang === i18next.language);
        return { id: reason.id, name: name.value };
      });
      setRejectReason(rejectReason);
    }
  }, [data]);

  // useEffect(() => {
  //   if (cityQuery?.data?.cities) {
  //     setCities(cityQuery?.data?.cities);
  //   }
  // }, [cityQuery.data]);

  const deviceType = (type) => {
    switch (type) {
      case "mobile":
        return t("Телефон");

      case "tablet":
        return t("Планшет");

      case "desktop":
        return t("ПК/ноутбук");

      default:
        return t("Не указано");
    }
  };

  const findAddress = () => {
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=Azerbaijan,+${searchAddress}&key=${process.env.REACT_APP_GOOGLE_MAP_KEY}`,
      )
      .then((response) => {
        const newPosition = new googleInstance.current.maps.LatLng(
          response.data?.results[0].geometry.location.lat,
          response.data?.results[0].geometry.location.lng,
        );
        marker.current.setPosition(newPosition);
        map.current.setCenter(newPosition);
        formik.setFieldValue(
          "lat",
          response.data?.results[0].geometry.location.lat,
        );
        formik.setFieldValue(
          "lng",
          response.data?.results[0].geometry.location.lng,
        );
      })
      .catch((error) => toast.error(error.message));
  };

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={id === null ? "Добавить объявление" : "Редактировать объявление"}
        breadcrumbs={[
          {
            slug: url,
            name: "Объявления",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <Modal show={showModalMap}>
                <Modal.Header closeButton onClick={() => toggleModalMap(false)}>
                  <Modal.Title>{t("Просмотр на карте")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <input
                      type={"text"}
                      className={"form-control"}
                      value={searchAddress}
                      onChange={(e) => setSearchAddress(e.target.value)}
                    />
                    <button
                      className={"btn btn-primary"}
                      onClick={() => findAddress()}
                      style={{ marginLeft: 10 }}
                    >
                      Найти
                    </button>
                  </div>
                  <div id={"map"} style={{ width: "100%", height: 300 }} />
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => toggleModalMap(false)}
                  >
                    {t("Закрыть")}
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal show={showModalLimit}>
                <Modal.Header
                  closeButton
                  onClick={() => toggleModalLimit(false)}
                >
                  <Modal.Title>{t("Лимиты пользователя")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <table className={"table table-striped"}>
                    <tbody>
                      {data.estate.data[0].user.limits.map((limit) => {
                        return (
                          <tr>
                            <td>
                              {limit.object_type_id === "none"
                                ? "Платные"
                                : limit.target + "/" + limit.object_type_id}
                            </td>
                            <td>
                              {limit.object_type_id === "none" &&
                              Number(limit.limit) <= 0
                                ? ""
                                : limit.active_to}
                            </td>
                            <td>{limit.limit}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => toggleModalMap(false)}
                  >
                    {t("Закрыть")}
                  </Button>
                </Modal.Footer>
              </Modal>
              <form className="row" onSubmit={formik.handleSubmit}>
                <Col md={12}>
                  <Fancybox
                    options={{
                      Carousel: {
                        infinite: false,
                      },
                    }}
                  >
                    <SortableList
                      items={formik.values.images}
                      axis={"xy"}
                      onSortEnd={({
                        oldIndex,
                        newIndex,
                        collection,
                        isKeySorting,
                      }) => {
                        let _items = [...formik.values.images];
                        let item = _items.splice(oldIndex, 1)[0];
                        _items.splice(newIndex, 0, item);
                        formik.setFieldValue("images", _items);
                      }}
                      pressDelay={200}
                    />
                  </Fancybox>
                </Col>
                <div className="col-md-6">
                  <div className="table-responsive mb-3">
                    <table className="table table-centered border mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th colSpan="2">{t("Данные объявления")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th scope="row">ID:</th>
                          <td>
                            <a
                              // target={"_blank"}
                              href={
                                "https://city.az/item/" + data.estate.data[0].id
                              }
                            >
                              {data.estate.data[0].id}
                            </a>
                            {data.estate.data[0].source_id > 0 && (
                              <a
                                target={"_blank"}
                                href={
                                  "https://ru.bina.az/items/" +
                                  data.estate.data[0].source_id
                                }
                              >
                                &nbsp;(оригинал)
                              </a>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Тип объекта")}:</th>
                          <td>{data.estate.data[0].object_type_id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Тип пользователя")}:</th>
                          <td>
                            {data.estate.data[0].user_type}
                            {JSON.parse(data.estate.data[0].has_agent_request)
                              .status && (
                              <Link
                                target={"_blank"}
                                style={{ color: "red", marginLeft: 10 }}
                                to={
                                  "/agent-request/form?id=" +
                                  JSON.parse(
                                    data.estate.data[0].has_agent_request,
                                  ).id
                                }
                              >
                                {t("нужна модерация")}
                              </Link>
                            )}
                            {Number(data.estate.data[0].user_type_id) === 2 && (
                              <a
                                href={`${process.env.REACT_APP_API_URL}/${i18next.language}/realtors/${data.estate.data[0].user.id}`}
                                target={"_blank"}
                              >
                                {" "}
                                {t("Страница агента")}
                              </a>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Цель")}:</th>
                          <td>
                            {Number(data.estate.data[0].target) === 1
                              ? t("Сдать")
                              : t("Продать")}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Тип недвижимости")}:</th>
                          <td>{data.estate.data[0].estate_type}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Пользователь")}:</th>
                          <td>
                            <div>ID: {data.estate.data[0].user?.id}</div>
                            <div>Имя: {data.estate.data[0].user?.name}</div>
                            <div>
                              Телефон: {data.estate.data[0].user?.phone}{" "}
                              <a
                                target={"_blank"}
                                href={
                                  "https://wa.me/" +
                                  data.estate.data[0].user?.phone
                                }
                              >
                                <img src={whatsapp} width={24} />
                              </a>
                            </div>
                            <div>
                              Баланс:
                              <div>
                                {" "}
                                - основной: {data.estate.data[0].user?.balance}
                              </div>
                              <div>
                                - бонусный:{" "}
                                {data.estate.data[0].user?.bonus_balance}
                              </div>
                            </div>
                            <div>
                              <a
                                href={"javascript:void(0);"}
                                onClick={() => toggleModalLimit(true)}
                              >
                                Лимиты
                              </a>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <TextInput
                                boxClass={"w100"}
                                value={formik.values.email}
                                touched={formik.touched.email}
                                error={formik.errors.email}
                                name={"email"}
                                label={"Email"}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    `email`,
                                    event.target.value,
                                  );
                                }}
                              />
                              {data.estate.data[0].user?.email_verified && (
                                <span
                                  className={"badge bg-success"}
                                  style={{ marginLeft: 5 }}
                                >
                                  <i
                                    className={"mdi mdi-account-check"}
                                    style={{ fontSize: 14 }}
                                  />
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <MultilangTextInput
                              label={"Заголовок"}
                              value={formik.values.title}
                              onChange={(text, lang) => {
                                formik.setFieldValue(`title.${lang}`, text);
                              }}
                              onBlur={formik.handleBlur}
                              error={formik.errors.title}
                              touched={formik.touched.title}
                              name={"title"}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Жилая зона")}:</th>
                          <td>{data.estate.data[0]?.complex?.nameString}</td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <TextInput
                              boxClass={""}
                              value={formik.values.address}
                              touched={formik.touched.address}
                              error={formik.errors.address}
                              name={"address"}
                              label={"Адрес"}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  `address`,
                                  event.target.value,
                                );
                              }}
                            />
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Город")}:</th>
                          <td>
                            {
                              data.estate.data[0].city_id?.name.find(
                                (item) => item.lang === i18next.language,
                              ).value
                            }
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Район")}:</th>
                          <td>
                            {
                              data.estate.data[0].area_id?.name.find(
                                (item) => item.lang === i18next.language,
                              )?.value
                            }
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Поселок")}:</th>
                          <td>
                            {
                              data.estate.data[0].place_id?.name.find(
                                (item) => item.lang === i18next.language,
                              ).value
                            }
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Координаты")}:</th>
                          <td>
                            {formik.values.lat}, {formik.values.lng}
                            {data.estate.data[0].lat !== "" &&
                              data.estate.data[0].lng !== "" && (
                                <a
                                  href={"#"}
                                  style={{ marginLeft: 10 }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    toggleModalMap(true);
                                    loader
                                      .load()
                                      .then((google) => {
                                        googleInstance.current = google;
                                        map.current = new google.maps.Map(
                                          document.getElementById("map"),
                                          {
                                            center: {
                                              lat: Number(formik.values.lat),
                                              lng: Number(formik.values.lng),
                                            },
                                            zoom: 16,
                                          },
                                        );
                                        marker.current = new google.maps.Marker(
                                          {
                                            position: {
                                              lat: Number(formik.values.lat),
                                              lng: Number(formik.values.lng),
                                            },
                                            map: map.current,
                                            title:
                                              formik.values.lat +
                                              ", " +
                                              formik.values.lng,
                                            draggable: true,
                                          },
                                        );

                                        marker.current.addListener(
                                          "dragend",
                                          (event) => {
                                            const position =
                                              marker.current.position;
                                            formik.setFieldValue(
                                              "lat",
                                              position.lat(),
                                            );
                                            formik.setFieldValue(
                                              "lng",
                                              position.lng(),
                                            );
                                          },
                                        );
                                      })
                                      .catch((e) => {
                                        // do something
                                      });
                                  }}
                                >
                                  {t("Посмотреть на карте")}
                                </a>
                              )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Дата создания")}:</th>
                          <td>
                            {moment(data.estate.data[0].created_at).format(
                              "HH:mm DD.MM.YYYY",
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Дата публикации")}:</th>
                          <td>
                            {data.estate.data[0].published_at &&
                              moment(data.estate.data[0].published_at).format(
                                "HH:mm DD.MM.YYYY",
                              )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">
                            {t("Дата последнего обновления")}:
                          </th>
                          <td>
                            {moment(data.estate.data[0].updated_at).format(
                              "HH:mm DD.MM.YYYY",
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <TextInput
                              boxClass={""}
                              value={formik.values.price}
                              touched={formik.touched.price}
                              error={formik.errors.price}
                              name={"price"}
                              label={"Цена"}
                              onChange={(event) => {
                                formik.setFieldValue(
                                  `price`,
                                  event.target.value,
                                );
                              }}
                            />
                          </td>
                        </tr>
                        {Number(data.estate.data[0].status) === 1 && (
                          <tr>
                            <th scope="row">{t("Последний шаг")}:</th>
                            <td>{data.estate.data[0].last_step}</td>
                          </tr>
                        )}
                        <tr>
                          <th scope="row">{t("Тип устройства")}:</th>
                          <td>
                            {deviceType(data.estate.data[0].device_type)}
                            {", "}
                            {data.estate.data[0].browser}
                            {", "}
                            {data.estate.data[0].platform}
                          </td>
                        </tr>
                        {Number(data.estate.data[0].target) === 1 && (
                          <>
                            <tr>
                              <th scope="row">{t("Срок аренды")}:</th>
                              <td>
                                {
                                  data.listTypeRent.find(
                                    (type) =>
                                      Number(type.id) ===
                                      Number(data.estate.data[0].type_rent),
                                  )?.name
                                }
                              </td>
                            </tr>
                            {Number(data.estate.data[0].type_rent) === 2 && (
                              <tr>
                                <th scope="row">
                                  {t("Предоплата в месяцах")}:
                                </th>
                                <td>
                                  {Number(data.estate.data[0].before_month) > 0
                                    ? data.estate.data[0].before_month
                                    : t("нет")}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <th scope="row">{t("Залог")}:</th>
                              <td>{data.estate.data[0].pledge}</td>
                            </tr>
                            <tr>
                              <th scope="row">{t("Комунальные")}:</th>
                              <td>
                                {
                                  data.listCommunal.find(
                                    (type) =>
                                      Number(type.id) ===
                                      Number(data.estate.data[0].communal),
                                  ).name
                                }
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="table-responsive">
                    <table className="table table-centered border mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th colSpan="2">{t("Свойства")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.estate.data[0].properties.map((prop) => {
                          return prop.value !== "" && prop.value !== null ? (
                            <tr
                              key={prop.id}
                              className={"allow-edit"}
                              onClick={() => {
                                setEditProps(prop);
                              }}
                            >
                              <th scope="row">
                                {
                                  prop?.property?.name.find(
                                    (name) => name.lang === i18next.language,
                                  ).value
                                }
                                :
                              </th>
                              <td>{prop.value !== "" ? prop.value : "--"}</td>
                            </tr>
                          ) : (
                            ""
                          );
                        })}
                        <tr key={"sale-type"}>
                          <th scope="row">{t("Как продаёте?")}</th>
                          <td>{getSaleType(data.estate.data[0].sale_type)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h4>{t("Другие объявления пользователя")}</h4>
                  {others.length === 0 && <p>{t("Нет данных")}</p>}
                  <table className="table table-centered border mb-0 table-response-mobile">
                    <tbody>
                      {others.slice(0, 5).map((other, index) => {
                        const status = data?.list.find((e) => {
                          return Number(e.id) === Number(other.status);
                        });
                        return (
                          <tr key={other.published_at + index}>
                            <td data-label={t("Состояние") + ":"}>
                              {other.deleted_at === null
                                ? status.name
                                : t("удалено")}
                            </td>
                            <td data-label={t("Дата публикации") + ":"}>
                              {moment(other.published_at).format(
                                "HH:mm DD.MM.YYYY",
                              )}
                            </td>
                            <td data-label={t("Цель") + ":"}>
                              {finder(TARGET, other.target)}
                            </td>
                            <td data-label={t("Тип") + ":"}>
                              {other.object_type_id}
                            </td>
                            <td>
                              <a
                                href={
                                  process.env.REACT_APP_API_URL +
                                  "/item/" +
                                  other.id
                                }
                                target={"_blank"}
                              >
                                {other.id}
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {others.length > 5 && (
                    <button
                      type={"button"}
                      className={"btn btn-info btn-sm"}
                      style={{ marginTop: 10, marginBottom: 10 }}
                      onClick={() => toggleModalOther(true)}
                    >
                      {t("Показать все")}
                    </button>
                  )}
                  <h4>{t("История статусов")}</h4>
                  {data.estate.data[0].histories.length === 0 && (
                    <p>{t("Нет данных")}</p>
                  )}
                  <table className="table table-centered border mb-0">
                    <tbody>
                      {data.estate.data[0].histories.map((history) => {
                        return (
                          <tr key={history.created_at}>
                            <td>{history.created_at}</td>
                            <td>{history.status}</td>
                            <td>{history.user}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h4 style={{ marginTop: 20 }}>
                    {t("История применения услуг")}
                  </h4>
                  {data.estate.data[0].serviceHistory.length > 0 ? (
                    <table className="table table-centered border mb-0">
                      <tbody>
                        {data.estate.data[0].serviceHistory.map((history) => {
                          return (
                            <tr>
                              <td>{history.id}</td>
                              <td>{history.created_at}</td>
                              <td>{history.type}</td>
                              <td>
                                {
                                  history.service.name.find(
                                    (str) => str.lang === i18next.language,
                                  ).value
                                }
                              </td>
                              <td>
                                {history.variant
                                  ? history.variant.name.find(
                                      (str) => str.lang === i18next.language,
                                    ).value
                                  : t("Остаток: ") + history.remainder}
                              </td>
                              <td>{history.user}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p>{t("Нет данных")}</p>
                  )}
                  <Modal size={"lg"} show={showModalOther}>
                    <Modal.Header
                      closeButton
                      onClick={() => toggleModalOther(false)}
                    >
                      <Modal.Title>{t("Все объявления")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <table className="table table-centered border mb-0">
                        <tbody>
                          {others.map((other, index) => {
                            const status = data?.list.find((e) => {
                              return Number(e.id) === Number(other.status);
                            });
                            return (
                              <tr key={other.published_at + index}>
                                <td>
                                  {other.deleted_at === null
                                    ? status.name
                                    : t("удалено")}
                                </td>
                                <td>{other.published_at}</td>
                                <td data-label={t("Цель") + ":"}>
                                  {finder(TARGET, other.target)}
                                </td>
                                <td>{other.object_type_id}</td>
                                <td>
                                  <a
                                    href={
                                      process.env.REACT_APP_API_URL +
                                      "/item/" +
                                      other.id
                                    }
                                    target={"_blank"}
                                  >
                                    {other.id}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => toggleModalOther(false)}
                      >
                        {t("Закрыть")}
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <EditProp
                  prop={editProp}
                  onCancel={() => setEditProps(null)}
                  estate_id={Number(searchParams.get("id"))}
                  onUpdate={() => {
                    refetch();
                    setEditProps(null);
                  }}
                />
                <div className="col-md-6">
                  <Selected
                    label={"Состояние"}
                    onChange={(value) => {
                      formik.setFieldValue(`status`, value);
                    }}
                    error={formik.errors.status}
                    name={"status"}
                    rows={{ value: "id", label: "name" }}
                    staticOptions={data?.list}
                    value={formik.values.status}
                  />
                </div>
                {Number(formik.values.status) === 4 && (
                  <div className="col-md-6">
                    <Selected
                      label={"Причина отклонения"}
                      onChange={(value) => {
                        formik.setFieldValue(`reject_reason`, value);
                      }}
                      error={formik.errors.reject_reason}
                      touched={formik.touched.reject_reason}
                      name={"reject_reason"}
                      rows={{ value: "id", label: "name" }}
                      staticOptions={rejectReason}
                      value={formik.values.reject_reason}
                    />
                  </div>
                )}
                <div className="col-md-12">
                  <TextInput
                    label={"Youtube"}
                    value={formik.values.video}
                    onChange={(event) => {
                      formik.setFieldValue(`video`, event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.video}
                    touched={formik.touched.video}
                    name={"video"}
                  />
                </div>
                <div className="col-md-12">
                  <MultilangTextInput
                    label={"Описание"}
                    value={formik.values.description}
                    onChange={(text, lang) => {
                      formik.setFieldValue(`description.${lang}`, text);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.description}
                    touched={formik.touched.description}
                    name={"description"}
                    type={"textarea"}
                  />
                </div>
                <div className="col-md-12">
                  <TextInput
                    type={"textarea"}
                    label={"Комментарий"}
                    value={formik.values.comment}
                    onChange={(event) => {
                      formik.setFieldValue(`comment`, event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.errors.comment}
                    touched={formik.touched.comment}
                    name={"comment"}
                  />
                </div>
                <div className="col-md-12 text-center">
                  <Button
                    label={"Сохранить"}
                    loading={loading}
                    style={"btn btn-primary w-md"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
